import React from 'react';

import theme from './RoomOptionTwoTierList.module.scss';

interface GroupQuantityProps {
    /** The group's quantity (`ConfiguratorGroupDto.quantity`). */
    quantity: number | null;
    /** The quantity's unit (e.g. "m²"), from the group's pricing field; omitted when absent. */
    unit?: string | null;
    /** Render as plain text matching the adjacent price (group card) instead of the default pill. */
    plain?: boolean;
}

/**
 * A group's quantity (value + unit, e.g. "3 m²"). The backend only fills `quantity` when the group's
 * "show quantity to buyers" flag is on (it's null otherwise), so any non-null value here is meant to
 * be shown. Shown as plain text next to the price on the group card (`plain`), and as a pill trailing
 * the group header title in the open group.
 */
export const GroupQuantity: React.FC<GroupQuantityProps> = ({ quantity, unit, plain }) => {
    if (quantity == null || quantity <= 0) {
        return null;
    }
    // Quantities can be fractional (e.g. area in m²); trim trailing zeros so a count reads "3", not "3.00".
    const formatted = Number(quantity.toFixed(2)).toString();
    return (
        <span className={plain ? theme.quantityText : theme.quantity}>
            {formatted}
            {unit ? <>&nbsp;{unit}</> : null}
        </span>
    );
};
